<template>
  <BaseCenteredModal v-model:is-modal-open="localIsModalOpen" size="medium">
    <template #body>
      <EventCard v-if="event" :event="event" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { defineComponent } from 'vue'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import { mapActions } from 'vuex'
import EventCard from '@/components/baseComponents/card/event/EventCard.vue'

export default defineComponent({
  name: 'EventModal',
  components: { EventCard, BaseCenteredModal },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: String,
      default: null
    }
  },
  emits: ['update:isModalOpen'],
  data() {
    return {
      event: null
    }
  },
  computed: {
    localIsModalOpen: {
      get() {
        return this.isModalOpen
      },
      set(value) {
        this.$emit('update:isModalOpen', value)
      }
    }
  },
  watch: {
    isModalOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.fetchEventById()
      }
    }
  },
  methods: {
    ...mapActions({
      processFetchEventByIdAction: 'agenda/fetchEventById2'
    }),
    fetchEventById() {
      if (this.eventId) {
        this.processFetchEventByIdAction({
          event_id: this.eventId
        }).then((response) => {
          this.event = response.event
        })
      }
    }
  }
})
</script>
